import { Routes } from '@angular/router';
import { AuthGuardService } from '../guards/auth-guard.service';
import { HomeComponent } from './home.component';

export const homeRoutes: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [ AuthGuardService ],
  }
];



// WEBPACK FOOTER //
// ./src/app/home/home.routes.ts